import {isPackageTypeChat, isPackageTypeInternet} from "./CheckUtil";
import ContentManager from "./ContentManager";
import OnboardCardPackage from "../component/base/onboard-card-package/OnboardCardPackage";
import React from "react";

export default class RemainingUsageManager {

    user = null;
    t = null;
    contentManager = null;

    constructor(user: null, t: null, i18n: null) {
        this.user = user;
        this.t = t;
        this.contentManager = new ContentManager(user, t, i18n);
    }

    getContentManager = () => {
        return this.contentManager;
    }

    hasPackages = () => {
        return (this.user?.quotas?.nonPurchase?.length > 0 || this.user?.quotas?.purchase?.length > 0 || this.user?.quotas?.favor?.length > 0 || this.user?.quotas?.campaign?.length > 0)
    }

    hasInternetPackage = () => {
        let internet = false;
        this.user.quotas?.nonPurchase?.forEach((value) => {
            if (isPackageTypeInternet(value.packageType)) internet = true;
        });
        this.user.quotas?.purchase?.forEach((value) => {
            if (isPackageTypeInternet(value.packageType)) internet = true;
        });
        this.user.quotas?.favor?.forEach((value) => {
            if (isPackageTypeInternet(value.packageType)) internet = true;
        });
        this.user.quotas?.campaign?.forEach((value) => {
            if (isPackageTypeInternet(value.packageType)) internet = true;
        });
        return internet;
    }

    hasInternetPackageUnlimited = () => {
        let unlimitedMB = false;
        this.user.quotas?.nonPurchase?.forEach((value, index) => {
            if (isPackageTypeInternet(value.packageType) && value.isUnlimited) unlimitedMB = true;
        });
        if (!unlimitedMB)
            this.user.quotas?.purchase?.forEach((value, index) => {
                if (isPackageTypeInternet(value.packageType) && value.isUnlimited) unlimitedMB = true;
            });
        if (!unlimitedMB)
            this.user.quotas?.favor?.forEach((value, index) => {
                if (isPackageTypeInternet(value.packageType) && value.isUnlimited) unlimitedMB = true;
            });
        if (!unlimitedMB)
            this.user.quotas?.campaign?.forEach((value, index) => {
                if (isPackageTypeInternet(value.packageType) && value.isUnlimited) unlimitedMB = true;
            });
        return unlimitedMB;
    }

    getQoutaRemainingTime = (time) => {
        let date = new Date(parseInt(time) - 60000);
        let hour = date.getHours().toString().length === 1 ? "0" + date.getHours() : date.getHours();
        let min = date.getMinutes().toString().length === 1 ? "0" + date.getMinutes() : date.getMinutes();
        return hour + ":" + min;
    }

    //------------------------------------

    renderDefinedRightsPackages = () => {
        if (this.user.quotas !== null && this.user.quotas?.nonPurchase !== null && this.user.quotas?.nonPurchase?.length > 0) {
            let hideRemainingUsage = true;
            let remainingUsageTitle = "";
            let isUnlimitedMessage = false;
            this.user.quotas?.nonPurchase?.map((value, index) => {
                if (isPackageTypeInternet(value.packageType) && !value.isFavor) {
                    hideRemainingUsage = false;
                    remainingUsageTitle = this.contentManager.homeRemainingUsageTitle(value);
                }
                if (this.hasChatPackage(value))
                    isUnlimitedMessage = true;
            });
            return <OnboardCardPackage
                title={this.contentManager.homePackageName()}
                remainingUsage={remainingUsageTitle}
                hideRemainingUsage={hideRemainingUsage}
                showUnlimitedMessage={isUnlimitedMessage}
                black={this.user?.business}
            />
        }
    }

    renderPurchasePackages = () => {
        if (this.user.quotas !== null && this.user.quotas?.purchase !== null && this.user.quotas?.purchase?.length > 0) {
            return this.user.quotas?.purchase?.map((value, index) => {
                let hideRemainingUsage = true;
                let remainingUsage = 0;
                if (isPackageTypeInternet(value.packageType) && !value.isFavor) {
                    hideRemainingUsage = false;
                    if (value.isUnlimited) remainingUsage = this.t('package_unlimited');
                    else remainingUsage = this.contentManager.homeRemainingUsageTitle(value);
                }
                return (
                    <OnboardCardPackage key={index}
                                        title={this.contentManager.homePurchaseTitle(value)}
                                        remainingUsage={remainingUsage}
                                        hideRemainingUsage={hideRemainingUsage}
                                        showUnlimitedMessage={this.hasChatPackage(value)}
                                        black={this.user?.business}
                    />
                );
            })
        }
    }

    renderFavorPackages = () => {
        if (this.user.quotas !== null && this.user.quotas?.favor !== null && this.user.quotas?.favor?.length > 0) {
            return this.user.quotas?.favor?.map((value, index) => {
                let hideRemainingUsage = true;
                let remainingUsage = 0;
                if (isPackageTypeInternet(value.packageType) && value.isFavor) {
                    hideRemainingUsage = false;
                    if (value.isUnlimited) remainingUsage = this.t('package_unlimited');
                    else remainingUsage = this.contentManager.homeRemainingUsageTitle(value);
                }
                return (
                    <OnboardCardPackage key={index}
                                        title={this.contentManager.homePurchaseTitle(value)}
                                        remainingUsage={remainingUsage}
                                        hideRemainingUsage={hideRemainingUsage}
                                        showUnlimitedMessage={this.hasChatPackage(value)}
                                        black={this.user?.business}
                    />
                );
            })
        }
    }

    renderCampaignPackages = () => {
        if (this.user.quotas !== null && this.user.quotas?.campaign !== null && this.user.quotas?.campaign?.length > 0) {
            return this.user.quotas?.campaign?.map((value, index) => {
                let hideRemainingUsage = true;
                let remainingUsage = 0;
                if (isPackageTypeInternet(value.packageType)) {
                    hideRemainingUsage = false;
                    remainingUsage = this.contentManager.homeCampaignPackageDescription(value);
                    if (value.info_desc_tr === null && value.info_desc_en === null && value.isUnlimited)
                        remainingUsage = this.t('package_unlimited');
                }
                return (
                    <OnboardCardPackage key={index}
                                        title={this.contentManager.homeCampaignPackageTitle(value)}
                                        remainingUsage={remainingUsage}
                                        hideRemainingUsage={hideRemainingUsage}
                                        showUnlimitedMessage={this.hasChatPackage(value)}
                                        black={this.user?.business}
                    />
                );
            })
        }
    }

    hasChatPackage = (value) => {
        return isPackageTypeChat(value.packageType) && value.isUnlimited;
    }
}



